module.exports = __webpack_public_path__ + "img/file_ext_small_link.307aa1a0.png";